import { getFormattedUTCDate } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { Styles } from "jspdf-autotable";

import { OrderDetails } from "../../orders.types";

interface renderHeaderProps {
  pdf: jsPDF;
  orderDetails?: OrderDetails;
  bigFontStyles: Partial<Styles>;
}

export const renderHeader = ({
  pdf,
  orderDetails,
  bigFontStyles
}: renderHeaderProps) => {
  autoTable(pdf, {
    theme: "plain",
    startY: 80,
    styles: { cellPadding: 5 },
    head: [
      [
        {
          content: `${t("Shipped on")} ${orderDetails?.deliveryDate ? getFormattedUTCDate(orderDetails?.deliveryDate, "DD MMMM, YYYY") : "-"}`,
          styles: {
            ...bigFontStyles,
            halign: "center",
            fillColor: "#ffffff",
            textColor: "#000000"
          }
        }
      ]
    ],
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
